<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @delete-item="deleteType"
            @success="alertSuccess($event)"
            @cancel="item = false"
        ></view-item>

        <list-items
            v-else
            title="ItemVendors"
            :items="assetVendors"
            
            @show-item="showItem"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" @click="item = {}"
                        v-show="hasPermissionCreate"
                        >Add Type</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'assetVendors',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        assetVendors() {
            const vendors = this.$store.state.assets.vendors
            console.log('vendors', vendors)
            return vendors
        },
    },

    methods: {
        cancelItem(){
            this.item = null
        },

        doSearch() {
            this.$store.dispatch('assets/listVendors')
        },

        showItem(id) {
            const item = this.assetVendors.find(x => x.id === id)
            this.item = {...item}
        },

        alertSuccess(message) {
            this.doToast('Success', `Vendor ${message}!`, 'success')
            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
